<div class="snackbar-container">
  <span class="message">{{ data.message | translate }}</span>
  <button
    mat-button
    color="accent"
    class="action-button"
    (click)="onRefreshClick()"
    (mouseenter)="onButtonMouseEnter()"
    (mouseleave)="onButtonMouseLeave()"
  >
    <span *ngIf="isHovering">{{ data.actionText | translate }}</span>
    <span *ngIf="!isHovering && countdown > 0">
      {{ 'snackbar.refreshing_in' | translate : { seconds: countdown } }}
    </span>
    <span *ngIf="!isHovering && countdown <= 0">{{ data.actionText | translate }}</span>
  </button>
</div>
